// extracted by mini-css-extract-plugin
export default {"container":"hEQfPG","button":"kvUMAu","mobile":"ykq4v2","title":"y9gi02","center":"Sx4F23","left":"YR7zMN","right":"JmTTBA"};